export const getPhone = (phone: string, additionalPhone?: string) => {
    if (!additionalPhone) {
        return phone;
    }

    return `${phone} ${additionalPhone}`;
};
